module.exports = __webpack_public_path__ + "img/golf_sub_title2.a02fefcb.jpg";